import PurchaseRepository from "../../Repository/PurchaseRepository";
import { v4 as uuidv4 } from "uuid";
import { unPurchaseItems } from "../inventory/itemsSlice";
import DefaultRepository from "../../Repository/DefaultRepository";
import LedgersRepository from "../../Repository/LedgersRepository";
import { toast } from "react-toastify";
import { clearInventory } from "../inventory/itemsSlice";
import { Toast } from "../components/Toast";

export const createPurchase = async (obj) => {
  let { ledger, vendor, ledger_detail, price, items, user } = obj;
  let sr = uuidv4();
  let companyCode = localStorage.getItem("companyCode");
  let { data } = await PurchaseRepository.purchasesModel({
    request: {
      method: "savePurchase",
      data: {
        company_code: companyCode,
        purchase: {
          company_code: companyCode,
          items: items,
          ship: {
            name: user.name,
            city: user?.address?.city,
            company: user?.company_name,
            street: user?.address?.street,
            phone: user?.address?.phone,
          },
          vendor: vendor,
          ledger: ledger,
          ledger_detail: ledger_detail,
          paid: 0,
          user_id: localStorage.getItem("email"),
          remaining: price || 0,
          srNum: sr,
        },
      },
    },
  });
  // let billNumber = data.response.data.purchaseNumber;
  // if (ledger != "") {
  //   await LedgersRepository.ledgerModel({
  //     request: {
  //       method: "updatePurchaseLedger",
  //       data: {
  //         _id: ledger,
  //         purchase: {
  //           srNum: sr,
  //           billNumber,
  //           date: +new Date(),
  //           detail: `Purchase Order # ${billNumber} entry created`,
  //           totalAmount: price,
  //           depositedAmount: 0,
  //           remainingAmount: price,
  //         },
  //       },
  //     },
  //   });
  // }
};

export const deletePurchase = async (id) => {
  let { data } = await PurchaseRepository.purchasesModel({
    request: {
      method: "deletePurchase",
      data: {
        _id: id,
      },
    },
  });
  if (data.response.status.statusCode == 200) {
    toast.configure();
    toast.success("Purchase Deleted Successfully");
  } else {
    toast.configure();
    toast.error("Error");
  }
};
export const updatePurchaseItems = async (obj) => {
  const { items, updated, order, dispatch, Total } = obj;

  let sr = uuidv4();

  await PurchaseRepository.purchasesModel({
    request: {
      method: "updatePurchase",
      data: {
        purchase: {
          ...order,
          remaining: Total,
          items: items,
          addedToStock: true,
        },
      },
    },
  });
  let { data } = await DefaultRepository.defaultModel({
    request: {
      method: "updateItem",
      data: {
        items: updated,
        action: "Purchase",
        user: localStorage.getItem("token"),
      },
    },
  });
  if (data.response.status.statusCode == 200) {
  } else {
    dispatch(clearInventory());
  }
  if (order.ledger) {
    await LedgersRepository.ledgerModel({
      request: {
        method: "updatePurchaseLedger",
        data: {
          _id: order.ledger,
          purchase: {
            srNum: sr,
            billNumber: order?.purchaseNumber,
            date: +new Date(),
            detail: `Purchase Order # ${order?.purchaseNumber} entry created`,
            totalAmount: Total,
            depositedAmount: 0,
            remainingAmount: Total,
          },
        },
      },
    });
  }
  if (data.response.status.statusCode == 200) {
  } else {
    dispatch(clearInventory());
  }
};

export const orderUpdate = async ({ props, paid, Total, items }) => {
  // let total_paid = parseInt(props.location.state.order.paid) + parseInt(paid);
  let data = await PurchaseRepository.purchasesModel({
    request: {
      method: "updatePurchase",
      data: {
        purchase: {
          _id: props.location.state.order._id,
          _rev: props.location.state.order._rev,
          purchaseNumber: props.location.state.order.purchaseNumber,
          company_code: localStorage.getItem("companyCode"),
          items: items ? items : props.location.state.order.items,
          ship: props.location.state.order.ship,
          vendor: props.location.state.order.vendor,
          ledger: props.location.state.selectedLedger,
          ledger_detail: props.location.state.ledger_detail,
          paid: props.location.state.order.paid,
          new_paid: paid,
          // remaining: Total - total_paid,
          remaining: Total - paid,
          srNum: props.location.state.order.srNum,
          addedToStock: props.location.state.order.addedToStock,
          purchaseMode: props?.location?.state?.order?.purchaseMode,
          bankId: props?.location?.state?.order?.bankId,
          total: Total,
        },
      },
    },
  });
  return data;
};

export const fetchLedger = async (idval) => {
  let total = 0;
  let pending = 0;
  let returnAmount = 0;
  let { data } = await LedgersRepository.ledgerModel({
    request: {
      method: "getPurchaseLedgersById",
      data: {
        _id: idval.ledger,
      },
    },
  });
  let ledger = data.response.data.purchaseLedgers[0].srNum;
  console.log("ledger", ledger);

  // ledger?.forEach((ledgerItem, idx) => {
  //   if (
  //     ledgerItem?.detail.startsWith("Purchase Returned") ||
  //     ledgerItem?.detail.startsWith("Sale Return") ||
  //     ledgerItem?.detail.startsWith("Returned Bill")
  //   ) {
  //     returnAmount += parseInt(ledgerItem?.totalAmount);
  //   } else {
  //     total += parseInt(ledgerItem?.totalAmount);
  //   }
  //   if (idx === 0) {
  //     pending = parseInt(ledgerItem?.balance);
  //   }
  // });

  return { ledger };
};
export const updateEntryDetails = async (state, history, sr) => {
  try {
    let { data } = await LedgersRepository.ledgerModel({
      request: {
        method: "updateLedgerEntry",
        data: {
          company_code: localStorage.getItem("companyCode"),
          ledgerId: state.ledger,
          ledgerType: "purchase",
          srNum: sr.ledger,
          updatedLedgerEntry: {
            detail: `Purchase Order # ${state.purchaseNumber} entry created`,
            totalAmount: Number(state.total || 0),
            depositedAmount: state.new_paid
              ? Number(state.paid) + Number(state.new_paid)
              : Number(state.paid),
            remainingAmount: state.new_paid
              ? Number(state.total) -
                (Number(state.paid) + Number(state.new_paid))
              : Number(state.total - state.paid),
            purchaseReturn: state?.purchaseReturn,
          },
        },
      },
    });
    if (data.response.data.ledgerId) {
      Toast("success", "Ledger Entry Updated");
    }
  } catch (err) {
    console.log(err);
    Toast("error", "Error");
    history.push("/inventory/admin/ledgers");
  }
};
export const updatePurchaseOrder = async ({ purchase, returned_items }) => {
  return await PurchaseRepository.purchasesModel({
    request: {
      method: "updatePurchase",
      data: {
        purchase: purchase,
        returned_items: returned_items,
      },
    },
  });
};
export const updatePurchaseEntry = async (order, total, rem, led) => {
  let entry = {
    srNum: "Purchase Return",
    date: +new Date(),
    detail: `Purchase Returned No.# ${order.purchaseNumber}`,
    billNumber: order.purchaseNumber,
    totalAmount: total,
    depositedAmount: 0,
    remainingAmount: -rem,
  };
  await LedgersRepository.ledgerModel({
    request: {
      method: "updatePurchaseLedger",
      data: {
        _id: led,
        purchase: entry,
      },
    },
  });
};

export const updateEntry = async (id, paid, totalAmount) => {
  let srnums = uuidv4();
  let date = +new Date();
  await LedgersRepository.ledgerModel({
    request: {
      method: "updatePurchaseLedger",
      data: {
        _id: id,
        purchase: {
          srNum: srnums,
          date: date,
          detail: "Balance Cleared",
          totalAmount: totalAmount,
          depositedAmount: paid,
          remainingAmount: Number(totalAmount) - Number(paid),
        },
      },
    },
  });
};
